import { useEffect } from "react";

import {
  closeLoginDialog,
  openLoginDialog,
} from "@/context/redux/reducers/dialog/login-dialog-slice";
import { useAuth } from "@/features/auth/shared/hooks/use-auth";

import { useAppDispatch, useAppSelector } from "./redux-hooks";

export const useLoginDialog = () => {
  const dispatch = useAppDispatch();
  const { isUnauthenticated } = useAuth();
  const { isOpen } = useAppSelector((state) => state.loginDialog);

  useEffect(() => {
    if (isUnauthenticated && !isOpen) {
      dispatch(openLoginDialog());
      return;
    }
    if (!isUnauthenticated && isOpen) {
      dispatch(closeLoginDialog());
    }
  }, [dispatch, isUnauthenticated, isOpen]);
};
